"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var VideoTransformDevice_1 = require("../devicecontroller/VideoTransformDevice");
var DefaultAudioVideoFacade = /*#__PURE__*/function () {
  function DefaultAudioVideoFacade(audioVideoController, videoTileController, realtimeController, audioMixController, deviceController, contentShareController) {
    _classCallCheck(this, DefaultAudioVideoFacade);
    this.audioVideoController = audioVideoController;
    this.videoTileController = videoTileController;
    this.realtimeController = realtimeController;
    this.audioMixController = audioMixController;
    this.deviceController = deviceController;
    this.contentShareController = contentShareController;
  }
  _createClass(DefaultAudioVideoFacade, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.audioVideoController.addObserver(observer);
      this.trace('addObserver');
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.audioVideoController.removeObserver(observer);
      this.trace('removeObserver');
    }
  }, {
    key: "setAudioProfile",
    value: function setAudioProfile(audioProfile) {
      this.trace('setAudioProfile', audioProfile);
      this.audioVideoController.setAudioProfile(audioProfile);
    }
  }, {
    key: "start",
    value: function start(options) {
      this.audioVideoController.start(options);
      this.trace('start');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.audioVideoController.stop();
      this.trace('stop');
    }
  }, {
    key: "getRTCPeerConnectionStats",
    value: function getRTCPeerConnectionStats(selector) {
      this.trace('getRTCPeerConnectionStats', selector ? selector.id : null);
      return this.audioVideoController.getRTCPeerConnectionStats(selector);
    }
  }, {
    key: "bindAudioElement",
    value: function bindAudioElement(element) {
      var result = this.audioMixController.bindAudioElement(element);
      this.trace('bindAudioElement', element.id, result);
      return result;
    }
  }, {
    key: "unbindAudioElement",
    value: function unbindAudioElement() {
      this.audioMixController.unbindAudioElement();
      this.trace('unbindAudioElement');
    }
  }, {
    key: "getCurrentMeetingAudioStream",
    value: function getCurrentMeetingAudioStream() {
      this.trace('getCurrentConferenceStream');
      return this.audioMixController.getCurrentMeetingAudioStream();
    }
  }, {
    key: "addAudioMixObserver",
    value: function addAudioMixObserver(observer) {
      this.trace('addAudioMixObserver');
      this.audioMixController.addAudioMixObserver(observer);
    }
  }, {
    key: "removeAudioMixObserver",
    value: function removeAudioMixObserver(observer) {
      this.trace('removeAudioMixObserver');
      this.audioMixController.removeAudioMixObserver(observer);
    }
  }, {
    key: "bindVideoElement",
    value: function bindVideoElement(tileId, videoElement) {
      this.videoTileController.bindVideoElement(tileId, videoElement);
      this.trace('bindVideoElement', {
        tileId: tileId,
        videoElementId: videoElement.id
      });
    }
  }, {
    key: "unbindVideoElement",
    value: function unbindVideoElement(tileId) {
      this.videoTileController.unbindVideoElement(tileId);
      this.trace('unbindVideoElement', tileId);
    }
  }, {
    key: "startLocalVideoTile",
    value: function startLocalVideoTile() {
      var result = this.videoTileController.startLocalVideoTile();
      this.trace('startLocalVideoTile', null, result);
      return result;
    }
  }, {
    key: "stopLocalVideoTile",
    value: function stopLocalVideoTile() {
      this.videoTileController.stopLocalVideoTile();
      this.trace('stopLocalVideoTile');
    }
  }, {
    key: "hasStartedLocalVideoTile",
    value: function hasStartedLocalVideoTile() {
      var result = this.videoTileController.hasStartedLocalVideoTile();
      this.trace('hasStartedLocalVideoTile', null, result);
      return result;
    }
  }, {
    key: "removeLocalVideoTile",
    value: function removeLocalVideoTile() {
      this.videoTileController.removeLocalVideoTile();
      this.trace('removeLocalVideoTile');
    }
  }, {
    key: "getLocalVideoTile",
    value: function getLocalVideoTile() {
      var result = this.videoTileController.getLocalVideoTile();
      this.trace('getLocalVideoTile');
      return result;
    }
  }, {
    key: "pauseVideoTile",
    value: function pauseVideoTile(tileId) {
      this.videoTileController.pauseVideoTile(tileId);
      this.trace('pauseVideoTile', tileId);
    }
  }, {
    key: "unpauseVideoTile",
    value: function unpauseVideoTile(tileId) {
      this.videoTileController.unpauseVideoTile(tileId);
      this.trace('unpauseVideoTile', tileId);
    }
  }, {
    key: "getVideoTile",
    value: function getVideoTile(tileId) {
      var result = this.videoTileController.getVideoTile(tileId);
      this.trace('getVideoTile', tileId);
      return result;
    }
  }, {
    key: "getAllRemoteVideoTiles",
    value: function getAllRemoteVideoTiles() {
      var result = this.videoTileController.getAllRemoteVideoTiles();
      this.trace('getAllRemoteVideoTiles');
      return result;
    }
  }, {
    key: "getAllVideoTiles",
    value: function getAllVideoTiles() {
      var result = this.videoTileController.getAllVideoTiles();
      this.trace('getAllVideoTiles');
      return result;
    }
  }, {
    key: "addVideoTile",
    value: function addVideoTile() {
      var result = this.videoTileController.addVideoTile();
      this.trace('addVideoTile', null, result.state());
      return result;
    }
  }, {
    key: "removeVideoTile",
    value: function removeVideoTile(tileId) {
      this.videoTileController.removeVideoTile(tileId);
      this.trace('removeVideoTile', tileId);
    }
  }, {
    key: "removeVideoTilesByAttendeeId",
    value: function removeVideoTilesByAttendeeId(attendeeId) {
      var result = this.videoTileController.removeVideoTilesByAttendeeId(attendeeId);
      this.trace('removeVideoTilesByAttendeeId', attendeeId, result);
      return result;
    }
  }, {
    key: "removeAllVideoTiles",
    value: function removeAllVideoTiles() {
      this.videoTileController.removeAllVideoTiles();
      this.trace('removeAllVideoTiles');
    }
  }, {
    key: "captureVideoTile",
    value: function captureVideoTile(tileId) {
      var result = this.videoTileController.captureVideoTile(tileId);
      this.trace('captureVideoTile', tileId);
      return result;
    }
  }, {
    key: "realtimeSubscribeToAttendeeIdPresence",
    value: function realtimeSubscribeToAttendeeIdPresence(callback) {
      this.realtimeController.realtimeSubscribeToAttendeeIdPresence(callback);
      this.trace('realtimeSubscribeToAttendeeIdPresence');
    }
  }, {
    key: "realtimeUnsubscribeToAttendeeIdPresence",
    value: function realtimeUnsubscribeToAttendeeIdPresence(callback) {
      this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(callback);
      this.trace('realtimeUnsubscribeToAttendeeIdPresence');
    }
  }, {
    key: "realtimeSetCanUnmuteLocalAudio",
    value: function realtimeSetCanUnmuteLocalAudio(canUnmute) {
      this.realtimeController.realtimeSetCanUnmuteLocalAudio(canUnmute);
      this.trace('realtimeSetCanUnmuteLocalAudio', canUnmute);
    }
  }, {
    key: "realtimeSubscribeToSetCanUnmuteLocalAudio",
    value: function realtimeSubscribeToSetCanUnmuteLocalAudio(callback) {
      this.realtimeController.realtimeSubscribeToSetCanUnmuteLocalAudio(callback);
      this.trace('realtimeSubscribeToSetCanUnmuteLocalAudio');
    }
  }, {
    key: "realtimeUnsubscribeToSetCanUnmuteLocalAudio",
    value: function realtimeUnsubscribeToSetCanUnmuteLocalAudio(callback) {
      this.realtimeController.realtimeUnsubscribeToSetCanUnmuteLocalAudio(callback);
    }
  }, {
    key: "realtimeCanUnmuteLocalAudio",
    value: function realtimeCanUnmuteLocalAudio() {
      var result = this.realtimeController.realtimeCanUnmuteLocalAudio();
      this.trace('realtimeCanUnmuteLocalAudio', null, result);
      return result;
    }
  }, {
    key: "realtimeMuteLocalAudio",
    value: function realtimeMuteLocalAudio() {
      this.realtimeController.realtimeMuteLocalAudio();
      this.trace('realtimeMuteLocalAudio');
    }
  }, {
    key: "realtimeUnmuteLocalAudio",
    value: function realtimeUnmuteLocalAudio() {
      var result = this.realtimeController.realtimeUnmuteLocalAudio();
      this.trace('realtimeUnmuteLocalAudio');
      return result;
    }
  }, {
    key: "realtimeSubscribeToMuteAndUnmuteLocalAudio",
    value: function realtimeSubscribeToMuteAndUnmuteLocalAudio(callback) {
      this.realtimeController.realtimeSubscribeToMuteAndUnmuteLocalAudio(callback);
      this.trace('realtimeSubscribeToMuteAndUnmuteLocalAudio');
    }
  }, {
    key: "realtimeUnsubscribeToMuteAndUnmuteLocalAudio",
    value: function realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback) {
      this.realtimeController.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback);
    }
  }, {
    key: "realtimeIsLocalAudioMuted",
    value: function realtimeIsLocalAudioMuted() {
      var result = this.realtimeController.realtimeIsLocalAudioMuted();
      this.trace('realtimeIsLocalAudioMuted');
      return result;
    }
  }, {
    key: "realtimeSubscribeToVolumeIndicator",
    value: function realtimeSubscribeToVolumeIndicator(attendeeId, callback) {
      this.realtimeController.realtimeSubscribeToVolumeIndicator(attendeeId, callback);
      this.trace('realtimeSubscribeToVolumeIndicator', attendeeId);
    }
  }, {
    key: "realtimeUnsubscribeFromVolumeIndicator",
    value: function realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback) {
      this.realtimeController.realtimeUnsubscribeFromVolumeIndicator(attendeeId, callback);
      this.trace('realtimeUnsubscribeFromVolumeIndicator', attendeeId, callback);
    }
  }, {
    key: "realtimeSubscribeToLocalSignalStrengthChange",
    value: function realtimeSubscribeToLocalSignalStrengthChange(callback) {
      this.realtimeController.realtimeSubscribeToLocalSignalStrengthChange(callback);
      this.trace('realtimeSubscribeToLocalSignalStrengthChange');
    }
  }, {
    key: "realtimeUnsubscribeToLocalSignalStrengthChange",
    value: function realtimeUnsubscribeToLocalSignalStrengthChange(callback) {
      this.realtimeController.realtimeUnsubscribeToLocalSignalStrengthChange(callback);
      this.trace('realtimeUnsubscribeToLocalSignalStrengthChange');
    }
  }, {
    key: "realtimeSendDataMessage",
    value: function realtimeSendDataMessage(topic,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data, lifetimeMs) {
      this.realtimeController.realtimeSendDataMessage(topic, data, lifetimeMs);
      this.trace('realtimeSendDataMessage');
    }
  }, {
    key: "realtimeSubscribeToReceiveDataMessage",
    value: function realtimeSubscribeToReceiveDataMessage(topic, callback) {
      this.realtimeController.realtimeSubscribeToReceiveDataMessage(topic, callback);
      this.trace('realtimeSubscribeToReceiveDataMessage');
    }
  }, {
    key: "realtimeUnsubscribeFromReceiveDataMessage",
    value: function realtimeUnsubscribeFromReceiveDataMessage(topic) {
      this.realtimeController.realtimeUnsubscribeFromReceiveDataMessage(topic);
      this.trace('realtimeUnsubscribeFromReceiveDataMessage');
    }
  }, {
    key: "realtimeSubscribeToFatalError",
    value: function realtimeSubscribeToFatalError(callback) {
      this.realtimeController.realtimeSubscribeToFatalError(callback);
    }
  }, {
    key: "realtimeUnsubscribeToFatalError",
    value: function realtimeUnsubscribeToFatalError(callback) {
      this.realtimeController.realtimeUnsubscribeToFatalError(callback);
    }
  }, {
    key: "subscribeToActiveSpeakerDetector",
    value: function subscribeToActiveSpeakerDetector(policy, callback, scoresCallback, scoresCallbackIntervalMs) {
      this.audioVideoController.activeSpeakerDetector.subscribe(policy, callback, scoresCallback, scoresCallbackIntervalMs);
      this.trace('subscribeToActiveSpeakerDetector');
    }
  }, {
    key: "unsubscribeFromActiveSpeakerDetector",
    value: function unsubscribeFromActiveSpeakerDetector(callback) {
      this.audioVideoController.activeSpeakerDetector.unsubscribe(callback);
      this.trace('unsubscribeFromActiveSpeakerDetector');
    }
  }, {
    key: "listAudioInputDevices",
    value: function listAudioInputDevices() {
      var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.deviceController.listAudioInputDevices(forceUpdate);
            case 2:
              result = _context.sent;
              this.trace('listAudioInputDevices', forceUpdate, result);
              return _context.abrupt("return", result);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "listVideoInputDevices",
    value: function listVideoInputDevices() {
      var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.deviceController.listVideoInputDevices(forceUpdate);
            case 2:
              result = _context2.sent;
              this.trace('listVideoInputDevices', forceUpdate, result);
              return _context2.abrupt("return", result);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "listAudioOutputDevices",
    value: function listAudioOutputDevices() {
      var forceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.deviceController.listAudioOutputDevices(forceUpdate);
            case 2:
              result = _context3.sent;
              this.trace('listAudioOutputDevices', forceUpdate, result);
              return _context3.abrupt("return", result);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "chooseAudioInputDevice",
    value: function chooseAudioInputDevice(device) {
      this.trace('chooseAudioInputDevice', device);
      return this.deviceController.chooseAudioInputDevice(device);
    }
  }, {
    key: "chooseVideoInputDevice",
    value: function chooseVideoInputDevice(device) {
      if (VideoTransformDevice_1.isVideoTransformDevice(device)) {
        // Don't stringify the device to avoid failures when cyclic object references are present.
        this.trace('chooseVideoInputDevice with transform device');
      } else {
        this.trace('chooseVideoInputDevice', device);
      }
      return this.deviceController.chooseVideoInputDevice(device);
    }
  }, {
    key: "chooseAudioOutputDevice",
    value: function chooseAudioOutputDevice(deviceId) {
      var result = this.deviceController.chooseAudioOutputDevice(deviceId);
      this.trace('chooseAudioOutputDevice', deviceId);
      return result;
    }
  }, {
    key: "addDeviceChangeObserver",
    value: function addDeviceChangeObserver(observer) {
      this.deviceController.addDeviceChangeObserver(observer);
      this.trace('addDeviceChangeObserver');
    }
  }, {
    key: "removeDeviceChangeObserver",
    value: function removeDeviceChangeObserver(observer) {
      this.deviceController.removeDeviceChangeObserver(observer);
      this.trace('removeDeviceChangeObserver');
    }
  }, {
    key: "createAnalyserNodeForAudioInput",
    value: function createAnalyserNodeForAudioInput() {
      var result = this.deviceController.createAnalyserNodeForAudioInput();
      this.trace('createAnalyserNodeForAudioInput');
      return result;
    }
  }, {
    key: "startVideoPreviewForVideoInput",
    value: function startVideoPreviewForVideoInput(element) {
      this.deviceController.startVideoPreviewForVideoInput(element);
      this.trace('startVideoPreviewForVideoInput', element.id);
    }
  }, {
    key: "stopVideoPreviewForVideoInput",
    value: function stopVideoPreviewForVideoInput(element) {
      this.deviceController.stopVideoPreviewForVideoInput(element);
      this.trace('stopVideoPreviewForVideoInput', element.id);
    }
  }, {
    key: "setDeviceLabelTrigger",
    value: function setDeviceLabelTrigger(trigger) {
      this.deviceController.setDeviceLabelTrigger(trigger);
      this.trace('setDeviceLabelTrigger');
    }
  }, {
    key: "mixIntoAudioInput",
    value: function mixIntoAudioInput(stream) {
      var result = this.deviceController.mixIntoAudioInput(stream);
      this.trace('mixIntoAudioInput', stream.id);
      return result;
    }
  }, {
    key: "chooseVideoInputQuality",
    value: function chooseVideoInputQuality(width, height, frameRate, maxBandwidthKbps) {
      this.deviceController.chooseVideoInputQuality(width, height, frameRate, maxBandwidthKbps);
      this.trace('chooseVideoInputQuality', {
        width: width,
        height: height,
        frameRate: frameRate,
        maxBandwidthKbps: maxBandwidthKbps
      });
    }
  }, {
    key: "getVideoInputQualitySettings",
    value: function getVideoInputQualitySettings() {
      var result = this.deviceController.getVideoInputQualitySettings();
      this.trace('getVideoInputQualitySettings');
      return result;
    }
  }, {
    key: "setContentAudioProfile",
    value: function setContentAudioProfile(audioProfile) {
      this.trace('setContentAudioProfile', audioProfile);
      this.contentShareController.setContentAudioProfile(audioProfile);
    }
  }, {
    key: "startContentShare",
    value: function startContentShare(stream) {
      var result = this.contentShareController.startContentShare(stream);
      this.trace('startContentShare');
      return result;
    }
  }, {
    key: "startContentShareFromScreenCapture",
    value: function startContentShareFromScreenCapture(sourceId, frameRate) {
      var result = this.contentShareController.startContentShareFromScreenCapture(sourceId, frameRate);
      this.trace('startContentShareFromScreenCapture');
      return result;
    }
  }, {
    key: "pauseContentShare",
    value: function pauseContentShare() {
      this.contentShareController.pauseContentShare();
      this.trace('pauseContentShare');
    }
  }, {
    key: "unpauseContentShare",
    value: function unpauseContentShare() {
      this.contentShareController.unpauseContentShare();
      this.trace('unpauseContentShare');
    }
  }, {
    key: "stopContentShare",
    value: function stopContentShare() {
      this.contentShareController.stopContentShare();
      this.trace('stopContentShare');
    }
  }, {
    key: "addContentShareObserver",
    value: function addContentShareObserver(observer) {
      this.contentShareController.addContentShareObserver(observer);
      this.trace('addContentShareObserver');
    }
  }, {
    key: "removeContentShareObserver",
    value: function removeContentShareObserver(observer) {
      this.contentShareController.removeContentShareObserver(observer);
      this.trace('removeContentShareObserver');
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "trace",
    value: function trace(name, input, output) {
      var meetingId = this.audioVideoController.configuration.meetingId;
      var attendeeId = this.audioVideoController.configuration.credentials.attendeeId;
      var s = "API/DefaultAudioVideoFacade/".concat(meetingId, "/").concat(attendeeId, "/").concat(name);
      if (typeof input !== 'undefined') {
        s += " ".concat(JSON.stringify(input));
      }
      if (typeof output !== 'undefined') {
        s += " -> ".concat(JSON.stringify(output));
      }
      this.audioVideoController.logger.info(s);
    }
  }, {
    key: "getRemoteVideoSources",
    value: function getRemoteVideoSources() {
      var result = this.audioVideoController.getRemoteVideoSources();
      this.trace('getRemoteVideoSources', null, result);
      return result;
    }
  }, {
    key: "promoteToPrimaryMeeting",
    value: function promoteToPrimaryMeeting(credentials) {
      this.audioVideoController.removeObserver(this); // Avoid adding multiple times
      this.audioVideoController.addObserver(this); // See note in `audioVideoWasDemotedFromPrimaryMeeting`
      var result = this.audioVideoController.promoteToPrimaryMeeting(credentials);
      this.trace('promoteToPrimaryMeeting', null, result); // Don't trace credentials
      return result;
    }
  }, {
    key: "demoteFromPrimaryMeeting",
    value: function demoteFromPrimaryMeeting() {
      this.trace('demoteFromPrimaryMeeting');
      this.audioVideoController.demoteFromPrimaryMeeting();
    }
  }, {
    key: "audioVideoWasDemotedFromPrimaryMeeting",
    value: function audioVideoWasDemotedFromPrimaryMeeting(_) {
      // `DefaultContentShareController` currently does not respond to the connection ending
      // so `contentShareDidStop` will not be called even if backend cleans up the connection.
      // Thus we try to pre-emptively clean up on client side.
      this.contentShareController.stopContentShare();
      this.audioVideoController.removeObserver(this);
    }
  }, {
    key: "transcriptionController",
    get: function get() {
      return this.realtimeController.transcriptionController;
    }
  }]);
  return DefaultAudioVideoFacade;
}();
exports.default = DefaultAudioVideoFacade;